import React, { useState, useEffect } from "react";
import AppLayout from "../components/AppLayout";
import CourseCard from "../components/CourseCard";
import { api } from "../api/client";
import { Loader2, BookOpen } from "lucide-react";

export default function MyCourses() {
    const [enrolled, setEnrolled] = useState([]);
    const [filter, setFilter] = useState("All");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/enrollments")
            .then((enrollments) => {
                setEnrolled((enrollments || []).map((e) => ({ ...e, enrolled: true })));
            })
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    const filtered = enrolled.filter((c) => {
        if (filter === "In progress") return c.progress > 0 && c.progress < 100;
        if (filter === "Completed") return c.progress >= 100;
        return true;
    });

    return (
        <AppLayout searchPlaceholder="Search your courses...">
            <div className="flex flex-wrap items-end justify-between gap-4 mb-10">
                <div>
                    <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight">My Courses</h1>
                    <p className="text-sm text-gray-400 mt-2">
                        {enrolled.length} active course{enrolled.length !== 1 ? "s" : ""}
                    </p>
                </div>
                <div className="flex gap-2">
                    {["All", "In progress", "Completed"].map((f) => (
                        <button
                            key={f}
                            onClick={() => setFilter(f)}
                            data-testid={`filter-${f.toLowerCase().replace(" ", "-")}`}
                            className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors border ${
                                filter === f
                                    ? "bg-ink-700 text-white border-white/10"
                                    : "text-gray-400 hover:text-white border-transparent"
                            }`}
                        >
                            {f}
                        </button>
                    ))}
                </div>
            </div>

            {loading ? (
                <div className="flex items-center justify-center py-24 text-gray-500">
                    <Loader2 className="w-5 h-5 animate-spin mr-2" /> Loading…
                </div>
            ) : filtered.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-24 text-center">
                    <BookOpen className="w-10 h-10 text-gray-600 mb-4" />
                    <p className="text-gray-400 font-semibold">
                        {enrolled.length === 0 ? "No enrolled courses" : "Nothing here"}
                    </p>
                    <p className="text-sm text-gray-600 mt-1">
                        {enrolled.length === 0
                            ? "Courses you enrol in will appear here."
                            : "Try a different filter."}
                    </p>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {filtered.map((c) => (
                        <CourseCard key={c.id} course={c} showProgress />
                    ))}
                </div>
            )}
        </AppLayout>
    );
}
